import React from 'react'
import { MorphReplace } from 'react-svg-morph'
import PropTypes from 'prop-types'

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      class="design-iconfont"
    >
      <path
        d="M12.0030074,1.45312493 C8.4680741,1.45231571 5.16779942,3.22245647 3.21303242,6.16773067 C1.25826541,9.11300487 0.908980251,12.8417059 2.28274384,16.0987794 L7.73415979,9.10224622 L11.561357,13.0283204 L14.2481734,9.63618176 L12.606816,7.99614272 L19.1616987,6.2387697 L17.4056441,12.7962892 L15.7484663,11.1377931 L11.6338668,16.1264649 L7.91345666,12.3111329 L3.40334928,18.0908204 C5.37581578,20.88498 8.58278047,22.546875 12.0030074,22.546875 C17.8278856,22.546875 22.5498823,17.8248783 22.5498823,12.0000001 C22.5498823,6.17512194 17.8278856,1.45312493 12.0030074,1.45312493 Z"
        fill-rule="nonzero"
      />
    </svg>
  )
}
const IndexLibIcon = (props) => {
  const { width, height, fill } = props
  return (
    <MorphReplace width={width} height={height} fill={fill}>
      <Icon />
    </MorphReplace>
  )
}

// 默认参数
IndexLibIcon.defaultProps = {
  width: 12,
  height: 12,
  fill: '#fff',
}
// 参数类型
IndexLibIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
}

export default IndexLibIcon
